import React, { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import classes from "./fleet.css"
import GatewayModal from "./GatewayModal/GatewayModal"
import FilterModal from "../CustomerFilterModal/FilterModal"
import { ReactComponent as FilterIcon } from "../CustomerFilterModal/Filter.svg"
import filterClass from "../CustomerFilterModal/FilterRow.css"


class Fleet extends Component {

  columns = [
    { name: "Friendly name", selector: "trivialName", sortable: true, left: true, minWidth: "180px", style: { fontSize: "14px" }},
    { name: "Serial number", selector: "serialNumber", sortable: true, left: true, style: { fontSize: "14px" }},
    { name: "Customer", selector: "customer", sortable: true, minWidth: "230px", style: { fontSize: "15px" }, format: (row) => this.state.customerNames[row.customer] ?? ""},
    { name: "Firmware", selector: "versionNumber", sortable: true, center: true, maxWidth: "20px", style: { fontSize: "14px" }},
  ]

  state = {
    gateways: [],
    filteredGateways: [],
    showGatewayModal: false,
    createMode: false,
    showFilterModal: false,
    selectedGateway: {},
    customerOptions: [],
    customerNames: {},
    dealOptions: {},
    filteredCustomer: "all-customers",
  }

  componentDidMount() {

    axios.get("/fleet/all").then(fleetResponse => {
      axios.get("/customers/allReduced").then(customerResponse => {
        axios.get("/deals/all/reduced").then(dealResponse => {

          let customerOptions = []
          let customerNames = {}
          let dealOptions = {}

          // Count how many gateways each customer has, for name generation
          let customerFleet = fleetResponse.data.reduce((acc, obj) => {
            acc[obj.customer] ? ++acc[obj.customer] : acc[obj.customer] = 1
            return acc
          }, {})

          // Process customers
          if (customerResponse.data) {
            customerResponse.data.forEach((el) => {

              // Use short company name if there is one
              let companyName = el.name
              if (el.shortName) {
                companyName = el.shortName
              }
              // Create customer option
              customerOptions.push({ label: el.name, value: el._id, shortName: companyName, fleetCount: customerFleet[el._id] ?? 0 })
              customerNames[el._id] = el.name
            })
          }

          // Process deals
          if (dealResponse.data) {
            dealResponse.data.forEach((el) => {
              if (!(el.customer in dealOptions)) { dealOptions[el.customer] = []}
              dealOptions[el.customer].push({ label: el.description, value: el._id })
            })
          }

          // Save into state
          this.setState({ 
            gateways: fleetResponse.data, 
            filteredGateways: fleetResponse.data, 
            customerOptions,
            customerNames, 
            dealOptions
          })
        })
      })
    })
  }

  displayModal = (shouldBeShown, gateway) => {
    this.setState({ showGatewayModal: shouldBeShown, selectedGateway: gateway, createMode: false })

    // Update list after update
    if (shouldBeShown === false) {
      setTimeout(() => {
        axios.get("/fleet/all").then(response => {
          if (response.data) {
            this.setState({ gateways: response.data, filteredGateways: (this.state.filteredCustomer !== "all-customers") ? response.data.filter(gateway => gateway.customer === this.state.filteredCustomer) : response.data })
          }
        })
      }, 500)
    }
  }

  createGatewayHandler = () => {
    var gateways = [...this.state.gateways]
    let newGateway = {
      trivialName: "",
      location: "",
      cpuUUID: "",
      serialNumber: "",
      model: "",
      pcieExpansion: "",
      customer: "",
      tpmPubKey: "",
    }
    gateways.push(newGateway)
    // Add and immediately show
    this.setState({ gateways: gateways, showGatewayModal: true, createMode: true, selectedGateway: newGateway })
  }

  updateFilter = (filterID) => {

    if (filterID !== "all-customers") {
      this.setState({ filteredCustomer: filterID, filteredGateways: this.state.gateways.filter(gateway => gateway.customer === filterID) })
    } else {
      this.setState({ filteredCustomer: filterID, filteredGateways: this.state.gateways })
    }
  }

  render() {
    return (
      <ContentContainer title="Gateway fleet">
        <div className={filterClass.buttonRow}>
          <button className={(this.state.filteredCustomer !== "all-customers") ? filterClass.filtered : filterClass.unfiltered } onClick={() => this.setState({ showFilterModal : true })}>
            {(this.state.filteredCustomer !== "all-customers") ? "Filtered" : "Filter"}
            <FilterIcon fill={(this.state.filteredCustomer !== "all-customers") ? "#FF6315" : "black"} className={filterClass.filterIcon}/>
          </button>
          <button onClick={this.createGatewayHandler} className={classes.addButton}>Add gateway</button>
        </div>

        <DataTable
          columns={this.columns}
          data={this.state.filteredGateways}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"serialNumber"}
          defaultSortAsc={false}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          className={classes.messageTable}
          onRowClicked={(gateway) => this.displayModal(true, gateway)}
        />


        {this.state.showGatewayModal && <>
        <GatewayModal
          shouldShow={this.state.showGatewayModal}
          selectedGateway={this.state.selectedGateway}
          createMode={this.state.createMode}
          customers={this.state.customerOptions}
          deals={this.state.dealOptions}
          closeModal={() => this.displayModal(false, {})}/>
        </>}

        { this.state.showFilterModal && <>
        <FilterModal
          shouldShow={this.state.showFilterModal}
          filteredCustomer={this.state.filteredCustomer}
          customerOptions={this.state.customerOptions}
          applyFilter={(customerID) => this.updateFilter(customerID)}
          closeModal={() => this.setState({ showFilterModal: false })}/>
        </>}

      </ContentContainer>
    );
  }

  timeDifferenceString = (epoch) => {

    let lastOnline = epoch;

    const secondsPerMinute = 60;
    const secondsPerHour = secondsPerMinute * 60;
    const secondsPerDay = secondsPerHour * 24;
    const secondsPerMonth = secondsPerDay * 30;
    const secondsPerYear = secondsPerDay * 365;
    const elapsedSeconds = (new Date() / 1000) - lastOnline;

    let relativeDifference = null;
    let timeUnit = null;

    // eslint-disable-next-line
    if (lastOnline == 0) {
      return "Never"
    }
    if (elapsedSeconds < secondsPerMinute) {
      relativeDifference = Math.round(elapsedSeconds);
      timeUnit = "second"
    }
    else if (elapsedSeconds < secondsPerHour) {
      relativeDifference = Math.round(elapsedSeconds/secondsPerMinute);
      timeUnit = "minute"
    }
    else if (elapsedSeconds < secondsPerDay ) {
      relativeDifference = Math.round(elapsedSeconds/secondsPerHour);
      timeUnit = "hour"
    }
    else if (elapsedSeconds < secondsPerMonth) {
      relativeDifference = Math.round(elapsedSeconds/secondsPerDay);
      timeUnit = "day"
    }
    else if (elapsedSeconds < secondsPerYear) {
      relativeDifference = Math.round(elapsedSeconds/secondsPerMonth);
      timeUnit = "month"
    }
    else {
      relativeDifference = Math.round(elapsedSeconds/secondsPerYear);
      timeUnit = "year"
    }


    if (relativeDifference === 1) {
      return (relativeDifference + " " + timeUnit + " ago");
    } else {
      return (relativeDifference + " " + timeUnit + "s ago");
    }
  }
}

export default Fleet;
